import script from "./GroupLabels.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupLabels.vue?vue&type=script&setup=true&lang=js"

import "./GroupLabels.vue?vue&type=style&index=0&id=3fb87bd8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fb87bd8"]])

export default __exports__